import React, { useState, useEffect, useContext, useCallback, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import 'react-toastify/dist/ReactToastify.css';
import localization from 'assets/localization/localization';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import DivLayout from "../../../../../components/sales/divLayout/divLayout";
import { Button } from "react-bootstrap";
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import { toast } from 'react-toastify';
import Images from 'assets/images/imageData';

const ApproveQuotation = ({
    match,
    quotation,
    getQuotation,
    quotationStatusChange
}) => {
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [isModal, setIsModal] = useState(false)
    const [successModal, setSuccessModal] = useState(false)
    const [formData, setFormData] = useState({ id: 0, status: 0, remarks: '' })

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getQuotation(match.params.id, 1)
            setIsLoading(false)
        })()
    }, [])

    useEffect(()=>{
        setFormData({...formData, id:parseInt(match.params.id)})
    },[quotation])
    
    const headerBtns = () => {
        return (
            <Fragment>
                <Button
                    onClick={() => {
                        setIsModal(true)
                        if(quotation?.quotation[0]?.status_id == 2){
                            setFormData({...formData, status:4})
                        }
                        else{
                            setFormData({...formData, status:2})
                        }
                        
                    }}
                    className="filter-hamburger btn btn-transparent"
                >
                    {quotation?.quotation[0]?.status_id == 2?'Client Approve':'Approve'}
                </Button>
                <Button
                    onClick={() => {
                        setIsModal(true)
                        if(quotation?.quotation[0]?.status_id == 2){
                            setFormData({...formData, status:5})
                        }
                        else{
                            setFormData({...formData, status:3})
                        }
                    }}
                    className="filter-hamburger btn btn-transparent"
                >
                    {quotation?.quotation[0]?.status_id == 2?'Client Reject':'Reject'}
                </Button>
            </Fragment>
        );
    }

    const mainBtn = () => {
        return (
            <Fragment>
                <Button
                    onClick={() => {
                        setIsModal(true)
                        setFormData({...formData, status:6})
                        
                    }}
                    className="filter-hamburger btn btn-transparent"
                >
                    {quotation?.quotation[0]?.status_id == 2?'Client Approve':'Approve'}
                </Button>
                <Button
                    onClick={() => {
                        setIsModal(true)
                        setFormData({...formData, status:7})
                    }}
                    className="filter-hamburger btn btn-transparent"
                >
                    {quotation?.quotation[0]?.status_id == 2?'Client Reject':'Reject'}
                </Button>
            </Fragment>
        );
    }

    const handleSubmit = () => {
        if (formData?.remarks == '') {
            toast.error('Enter Remarks Field')
            return
        }
        else {
            (async () => {
                setIsLoading(true)
                setIsModal(false)
                const res = await quotationStatusChange(formData)
                setIsLoading(false)
                if (res) {
                    setIsModal(false);
                    setSuccessModal(true);
                }
            })()
        }
    }
    let btn;
    if(quotation?.quotation?.[0]?.status_id == 4){
        btn = mainBtn
    }
    else if(quotation?.quotation?.[0]?.status_id == 1 || quotation?.quotation?.[0]?.status_id == 2){
        btn = headerBtns
    }

    return (
        <Layout
            title="Quotation Listing"
            Buttons={btn}
            isGoback
            isLoading={isLoading}
        >
            <div className="panel-card card-details" width="100%">
                <div className="panel-heading">{localization.quotation}</div>
                <div className="panel-body">
                    <div className="details-listing detail_alignment">
                        <DivLayout heading={"Client Name"} data={quotation?.quotation?.[0]?.client_name} />
                        <DivLayout heading={"Solution"} data={quotation?.quotation?.[0]?.solution_type} />
                        <DivLayout heading={"AMC Cost"} data={quotation?.quotation?.[0]?.amc_cost} />
                        <DivLayout heading={"Server Charge"} data={quotation?.quotation?.[0]?.server_charge} />
                        <DivLayout heading={"Status"} data={quotation?.quotation?.[0]?.status} />
                        <DivLayout heading={"Created By"} data={quotation?.quotation?.[0]?.created_by} />
                        <DivLayout heading={"Created At"} data={quotation?.quotation?.[0]?.created_at} />
                        <DivLayout heading={"Updated At"} data={quotation?.quotation?.[0]?.updated_at} />
                        {quotation?.quotation_material?.map((element, index) => {
                            return (<><hr/>
                                <DivLayout heading={index + 1 + '. ' + "Material"} data={element?.material_name} />
                                <DivLayout heading={"Category"} data={element?.category_name} />
                                <DivLayout heading={"Quantity"} data={element?.quantity} />
                                <DivLayout heading={"Unit Price"} data={element?.unit_price} />
                            </>
                            )
                        })}
                    </div>
                </div>
            </div>
            {![1].includes(quotation?.quotation?.[0]?.status_id) &&
                quotation?.quotation_logs?.map((elem, ind) => {
                    return (
                        <div className="panel-card card-details" width="100%">
                            <div className="panel-heading">{localization.remark}s for {elem?.remarks_by}</div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <DivLayout heading={"Remarks"} data={elem?.remarks} />
                                </div>
                            </div>
                        </div>
                    )
                })
            }
            <ModalPop
                title="Add Remarks"
                show={isModal}
                handleModalHide={() => setIsModal(false)}
            >
                <TextAreaInput
                    type="text"
                    rows={3}
                    className={`inline-css scrollbar-styling`}
                    label="Add Remarks"
                    value={formData?.remarks}
                    inputValue={formData?.remarks}
                    errorMsg={localization.isRequired}
                    handleChange={(e) => {
                        setFormData({ ...formData, remarks: e.target.value })
                    }}
                />
                <Button
                    onClick={handleSubmit}
                    className="filter-hamburger btn btn-transparent"
                >
                    Submit
                </Button>
            </ModalPop>
            <ModalPop
                title="Status Changed"
                show={successModal}
                handleModalHide={() => setSuccessModal(false)}
            >
                <div className="text-center">
                    <div className="success">
                        <img src={Images?.tick} alt="" />
                    </div>
                    <h5>Quotation Status Changed</h5>
                    <Link to={`${baseUrl}/project-onboarding/approve-quotations`} className="btn btn-primary mb-4">View Quotations</Link>
                </div>
            </ModalPop>
        </Layout>
    );
};

export default ApproveQuotation;
